/**
 * Trim leading and trailing whitespace from an object of strings.
 */
export const trimObject = (
  obj: Record<string, string>,
): Record<string, string> =>
  Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [key, value.trim()]),
  )
